import { render, staticRenderFns } from "./list-pre-general.vue?vue&type=template&id=7208432c"
import script from "./list-pre-general.vue?vue&type=script&lang=js"
export * from "./list-pre-general.vue?vue&type=script&lang=js"
import style0 from "./list-pre-general.vue?vue&type=style&index=0&id=7208432c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports